
// Form steps based on the flow diagram
export const FORM_STEPS = {
    INJURY: 1,
    REPRESENTATION: 2,
    FAULT: 3,
    DETAILS: 4,
    WHEN: 5,
    PERSONAL_INFO: 6,  // Replaces steps 6-9
    COMPLETED: 7,      // Updated from 10 to 7
};

export interface FormData {
    ProductId: number;
    treatedBy: string;
    physicalInjury: string;
    hasAttorney: string;
    accidentFault: string;
    caseDescription: string;
    date: Date | null; // Using Date type
    zip: number;
    state: string;
    userIp: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    // default values
    source: string;
    interestScale: string;
    apiId: string;
    apiPassword: string;
    webSiteUrl: string;
    tcpa: string;
    accidentType: string;
    tcpaText: string;
    price: string;
    userAgent: string;
    leadLanguage: string;
    dateSelection?: string; // Track which date option was selected
    Years: number; // New property to track years based on the selection
    jornayaLeadId?: string; // Optional property for the Jornaya Lead ID
    isDequalified?: boolean; // New property to track if the lead is dequalified
    dequalReason?: string; // New property to track the reason for dequalification
    trustedFormUrl: string; // Add this field to store the TrustedForm URL
}